import { bindActionCreators, compose } from "redux";
import { connect } from "react-redux";
import { siteActions } from "../../../../redux/actions/siteActions";
import ViewSiteDetail from "./ViewSiteDetail";
import { withRouter } from "react-router";

const mapStateToProps = state => {
  return {
    siteDataById: state.siteReducer.siteDataById,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(
      {
        ...siteActions
      },
      dispatch
    )
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewSiteDetail);



// WEBPACK FOOTER //
// ./src/app/views/manageSite/viewSiteList/viewSiteDetail/index.js